import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { useGetTranslations, useLang } from "@/common/Contexts/LanguageContext";
import longTranslationsAr from "@data/translations_v2/ar/long.json";
import longTranslationsEn from "@data/translations_v2/en/long.json";
import shortTranslationsAr from "@/i18n/translations_v2/ar.json";
import shortTranslationsEn from "@/i18n/translations_v2/en.json";
import namespaces from "@/i18n/namespaces";
import { checkTestFlag } from "@/common/config/websiteConfig";
var translationFuncCreator = function translationFuncCreator(translations_data) {
  return function (key) {
    var _translations_data$pa, _translations_data$pa2;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var lbl = (_translations_data$pa = translations_data === null || translations_data === void 0 ? void 0 : (_translations_data$pa2 = translations_data[params.ns]) === null || _translations_data$pa2 === void 0 ? void 0 : _translations_data$pa2[key]) !== null && _translations_data$pa !== void 0 ? _translations_data$pa : null;
    if (lbl === null) {
      namespaces.forEach(function (ns) {
        if (lbl === null) {
          var _translations_data$ns, _translations_data$ns2;
          lbl = (_translations_data$ns = translations_data === null || translations_data === void 0 ? void 0 : (_translations_data$ns2 = translations_data[ns]) === null || _translations_data$ns2 === void 0 ? void 0 : _translations_data$ns2[key]) !== null && _translations_data$ns !== void 0 ? _translations_data$ns : null;
        }
      });
    }
    if (lbl === null) {
      lbl = key;
    }
    lbl = typeof lbl === "string" ? lbl : JSON.stringify(key);
    var finalText = (lbl || "").replace(/{{(.*?)}}/g, function (match, p1) {
      return params[p1.trim()] || match;
    });
    if (__IS_CSR__ && window.location.href.includes("/en")) {
      if (checkTestFlag("TEST_DEBUG_I18n")) {
        return "**".concat(finalText, "**");
      }
    }
    return finalText;
  };
};

// handel old Class React Components using HOC
//@fixme @ibrahim remove with from all class Components
export var withTranslation = function withTranslation(groups) {
  return function (WrappedComponent) {
    // This is now a functional component
    return function TranslatedComponent(props) {
      var translation_data = useGetTranslations();
      // Return the WrappedComponent (which is a class component) with the translation function
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        t: translationFuncCreator(translation_data)
      }));
    };
  };
};

// Modern React Hooks
var useTranslation = function useTranslation() {
  var ns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["web_common"];
  var translations_v1 = useGetTranslations();
  var lang = useLang();
  return {
    t: translationFuncCreator(translations_v1),
    tLong: translationFuncCreator(lang === "ar" ? longTranslationsAr : longTranslationsEn),
    tShort: translationFuncCreator(lang === "ar" ? shortTranslationsAr : shortTranslationsEn)
  };
};
export default useTranslation;